import { Outlet } from 'react-router'

import { Breadcrumb } from '@ui/components/navigation'
import { ExtraParams } from '@ui/interfaces/navigation'
import { AllPipelinesWrapper, PipelineErrors } from '@ui/pages/pipelines'
import { ExistingPipeline, NewPipeline } from '@ui/pages/pipelinesWorkflow'
import { RouteNamesEnum } from '@ui/router/routes'

export const PipelineRoutes = () => {
  return {
    name: RouteNamesEnum.ALL_PIPELINES,
    path: 'pipelines',
    element: <Outlet />,
    handle: {
      crumb: (data: ExtraParams) => (
        <Breadcrumb crumbStyle={data.crumbStyle} to={`/instances/${data.instanceId}/pipelines`} label="Pipelines" />
      ),
    },
    children: [
      {
        index: true,
        element: <AllPipelinesWrapper />,
      },
      {
        name: RouteNamesEnum.NEW_PIPELINE,
        path: 'new',
        element: <NewPipeline />,
        handle: {
          crumb: (data: ExtraParams) => (
            <Breadcrumb
              crumbStyle={data.crumbStyle}
              to={`/instances/${data.instanceId}/pipelines`}
              label="New Pipeline"
            />
          ),
        },
      },
      {
        name: RouteNamesEnum.EXISTING_PIPELINE,
        path: ':pipelineId',
        element: <Outlet />,
        handle: {
          crumb: (data: ExtraParams) => (
            <Breadcrumb
              crumbStyle={data.crumbStyle}
              to={`/instances/${data.instanceId}/pipelines/${data.pipelineId}`}
              label={data.pipelineName}
            />
          ),
        },
        children: [
          {
            index: true,
            element: <ExistingPipeline />,
          },
          {
            name: RouteNamesEnum.EXISTING_PIPELINE_NODE,
            path: ':nodeId',
            element: <ExistingPipeline />,
            handle: {
              crumb: (data: ExtraParams) => (
                <Breadcrumb
                  crumbStyle={data.crumbStyle}
                  to={`/instances/${data.instanceId}/pipelines/${data.pipelineId}/${data.nodeId}`}
                  label="Transformation"
                />
              ),
            },
          },
          {
            name: RouteNamesEnum.PIPELINE_ERRORS,
            path: 'errors',
            element: <PipelineErrors />,
            handle: {
              crumb: (data: ExtraParams) => (
                <Breadcrumb
                  crumbStyle={data.crumbStyle}
                  to={`/instances/${data.instanceId}/pipelines/${data.pipelineId}/errors`}
                  label="Errors"
                />
              ),
            },
          },
        ],
      },
    ],
  }
}
